import apiService from './api.service';

export interface AlertInstance {
  id: string;
  tenant_id: string;
  alert_rule_id: string;
  application_id?: string;
  source: string;
  status: 'firing' | 'resolved' | 'acknowledged';
  triggered_at: string;
  resolved_at?: string;
  acknowledged_at?: string;
  acknowledged_by?: string;
  triggered_value?: number;
  message?: string;
  labels?: Record<string, any>;
  annotations?: Record<string, any>;
  metadata?: Record<string, any>;
  created_at: string;
  alert_rule?: {
    id: string;
    name: string;
    description?: string;
    severity: string;
    alert_type: string;
  };
  application?: {
    id: string;
    name: string;
  };
}

export interface AlertInstanceFilters {
  status?: string;
  severity?: string;
  application_id?: string;
  source?: string;
  start_date?: string;
  end_date?: string;
}

const alertInstanceService = {
  async getAll(filters?: AlertInstanceFilters, limit = 20, offset = 0): Promise<{ success: boolean; data: AlertInstance[]; meta?: { total: number; limit: number; offset: number } }> {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.severity) params.append('severity', filters.severity);
    if (filters?.application_id) params.append('application_id', filters.application_id);
    if (filters?.source) params.append('source', filters.source);
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    const response = await apiService.get(`/v1/alerts/instances?${params.toString()}`);
    return response;
  },

  async getById(id: string) {
    const response = await apiService.get(`/v1/alerts/instances/${id}`);
    return response;
  },

  async acknowledge(id: string) {
    const response = await apiService.post(`/v1/alerts/instances/${id}/acknowledge`, {});
    return response;
  },

  async acknowledgeAll(applicationId?: string) {
    const response = await apiService.post(`/v1/alerts/instances/acknowledge-all`, applicationId ? { application_id: applicationId } : {});
    return response;
  },

  async resolve(id: string) {
    const response = await apiService.post(`/v1/alerts/instances/${id}/resolve`, {});
    return response;
  },

  async getStats() {
    const response = await apiService.get('/v1/alerts/instances/stats');
    return response;
  },

  async getFiring(limit = 10, offset = 0): Promise<{ success: boolean; data: AlertInstance[]; meta?: { total: number; limit: number; offset: number } }> {
    const response = await apiService.get(`/v1/alerts/instances/firing?limit=${limit}&offset=${offset}`);
    return response;
  },
};

export default alertInstanceService;
